import { render, staticRenderFns } from "./UspBlock.vue?vue&type=template&id=5ab8f3b4&"
import script from "./UspBlock.js?vue&type=script&lang=js&"
export * from "./UspBlock.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports